import { AdblockService } from "../common/api.service";

const initialState = {};

const state = { ...initialState };

const getters = {};

const mutations = {};

const actions = {
  getState(_, params) {
    return AdblockService.getState(params).then(({ data }) => data);
  },
  updateState(_, { id, _id, ...body }) {
    return AdblockService.updateState(body).then(({ data }) => data);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
